module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.form.config), function(group, legend) {
    return _c('fieldset', [_c('legend', [_vm._v(_vm._s(legend))]), _vm._v(" "), _vm._l((group), function(field, index) {
      return _c('form-group', {
        key: index,
        attrs: {
          "label": field.label,
          "label-col": 2,
          "control-col": 10,
          "error": _vm.errors[field.name]
        }
      }, [_c('text-input', {
        model: {
          value: (_vm.form.fields[field.name]),
          callback: function($$v) {
            _vm.$set(_vm.form.fields, field.name, $$v)
          },
          expression: "form.fields[field.name]"
        }
      })], 1)
    })], 2)
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.submitting
    }
  }, [(_vm.submitting) ? [_vm._v("Zapisywanie")] : [_vm._v("Zapisz")]], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f88607d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormData.vue
// module id = 457
// module chunks = 1